const requestMethods = {
  vehicleEndpoints: [
    'GET',
    'POST',
    'PUT',
  ],
};

export default requestMethods;
